export default __webpack_public_path__ + "static/media/Ray Wang.06cca6c7.jpg";